module.exports=[
  {
    "id": 8752,
    "first": "Joe",
    "last": "Biden",
    "show_on_widget": true,
    "show_on_delegate_tracker": true,
    "dropped_out": false
  },
  {
    "id": 8758,
    "first": "Michael",
    "last": "Bloomberg",
    "show_on_widget": false,
    "show_on_delegate_tracker": true,
    "dropped_out": true
  },
  {
    "id": 8750,
    "first": "Tulsi",
    "last": "Gabbard",
    "show_on_widget": false,
    "show_on_delegate_tracker": true,
    "dropped_out": false
  },
  {
    "id": 8751,
    "first": "Bernie",
    "last": "Sanders",
    "show_on_widget": true,
    "show_on_delegate_tracker": true,
    "dropped_out": false
  },
  {
    "id": 8757,
    "first": "Elizabeth",
    "last": "Warren",
    "show_on_widget": false,
    "show_on_delegate_tracker": true,
    "dropped_out": true
  },
  {
    "id": 8766,
    "first": "Michael",
    "last": "Bennet",
    "show_on_widget": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8753,
    "first": "Cory",
    "last": "Booker",
    "show_on_widget": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8754,
    "first": "Pete",
    "last": "Buttigieg",
    "show_on_widget": false,
    "show_on_delegate_tracker": true,
    "dropped_out": true
  },
  {
    "id": 8765,
    "first": "John",
    "last": "Delaney",
    "show_on_widget": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8749,
    "first": "Amy",
    "last": "Klobuchar",
    "show_on_widget": false,
    "show_on_delegate_tracker": true,
    "dropped_out": true
  },
  {
    "id": 8759,
    "first": "Deval",
    "last": "Patrick",
    "show_on_widget": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8755,
    "first": "Tom",
    "last": "Steyer",
    "show_on_widget": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8756,
    "first": "Andrew",
    "last": "Yang",
    "show_on_widget": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8767,
    "first": "",
    "last": "Uncommitted",
    "show_on_widget": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  }
]